"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var NoResultsWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttext-align: center;\n\tpadding-top: ", ";\n\tpadding-bottom: ", ";\n"], ["\n\ttext-align: center;\n\tpadding-top: ", ";\n\tpadding-bottom: ", ";\n"])), globalVars_module_scss_1.default.spacing100, globalVars_module_scss_1.default.spacing100);
NoResultsWrapper.displayName = 'NoResultsWrapper';
var Headline = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 21px;\n\tfont-weight: ", ";\n\tline-height: 1.2em;\n"], ["\n\tfont-size: 21px;\n\tfont-weight: ", ";\n\tline-height: 1.2em;\n"])), globalVars_module_scss_1.default.fontWeightBold);
Headline.displayName = 'Headline';
var LargeCopy = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: ", ";\n\tfont-weight: ", ";\n\tline-height: 1.4em;\n\tmargin: ", " 0;\n"], ["\n\tfont-size: ", ";\n\tfont-weight: ", ";\n\tline-height: 1.4em;\n\tmargin: ", " 0;\n"])), globalVars_module_scss_1.default.fontSizeLarge, globalVars_module_scss_1.default.fontWeightNormal, globalVars_module_scss_1.default.spacing25);
LargeCopy.displayName = 'LargeCopy';
var ChildrenContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin: ", " 0;\n"], ["\n\tmargin: ", " 0;\n"])), globalVars_module_scss_1.default.spacing25);
ChildrenContainer.displayName = 'ChildrenContainer';
var NoResults = /** @class */ (function (_super) {
    __extends(NoResults, _super);
    function NoResults(props) {
        return _super.call(this, props) || this;
    }
    NoResults.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(NoResultsWrapper, null,
                React.createElement(Headline, null, this.props.title),
                React.createElement(LargeCopy, null, this.props.message),
                React.createElement(ChildrenContainer, null, this.props.children))));
    };
    return NoResults;
}(React.Component));
exports.NoResults = NoResults;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
